/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePageContentFragment} from '@amblique/contentful/app/contentful/fragments/page-content/base-page-content.fragment';
import {BaseAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion/base-accordion.fragment';
import {BaseAccordionPanelFragment} from '@amblique/contentful/app/contentful/fragments/accordion-panel/base-accordion-panel.fragment';
import {BaseActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/base-action-links.fragment';
import {BaseCardFragment} from '@amblique/contentful/app/contentful/fragments/card/base-card.fragment';
import {BaseCarouselFragment} from '@amblique/contentful/app/contentful/fragments/carousel/base-carousel.fragment';
import {BaseEmbedPanelFragment} from '@amblique/contentful/app/contentful/fragments/embed-panel/base-embed-panel.fragment';
import {BaseFeatureListFragment} from '@amblique/contentful/app/contentful/fragments/feature-list/base-feature-list.fragment';
import {BaseHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/base-hero-banner.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';
import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseSplitPanelFragment} from '@amblique/contentful/app/contentful/fragments/split-panel/base-split-panel.fragment';
import {BaseTeaserTileFragment} from '@amblique/contentful/app/contentful/fragments/teaser-tile/base-teaser-tile.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const PageContentFragment = gql`
  ${BaseAccordionFragment}
  ${BaseAccordionPanelFragment}
  ${BaseActionLinksFragment}
  ${BaseCardFragment}
  ${BaseCarouselFragment}
  ${BaseEmbedPanelFragment}
  ${BaseFeatureListFragment}
  ${BaseHeroBannerFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${BaseMediaCarouselFragment}
  ${BasePageContentFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseSplitPanelFragment}
  ${BaseTeaserTileFragment}
  ${BaseVideoFragment}

  fragment PageContentFragment on PageContent {
    ...BasePageContentFragment

    bottomContentBlocksCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on AccordionPanel {
          ...BaseAccordionPanelFragment
        }
        ... on ActionLinks {
          ...BaseActionLinksFragment
        }
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on TeaserTile {
          ...BaseTeaserTileFragment
        }
      }
    }
    topContentBlocksCollection {
      items {
        __typename
        ... on Accordion {
          ...BaseAccordionFragment
        }
        ... on ActionLinks {
          ...BaseActionLinksFragment
        }
        ... on Card {
          ...BaseCardFragment
        }
        ... on Carousel {
          ...BaseCarouselFragment
        }
        ... on EmbedPanel {
          ...BaseEmbedPanelFragment
        }
        ... on FeatureList {
          ...BaseFeatureListFragment
        }
        ... on HeroBanner {
          ...BaseHeroBannerFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on Link {
          ...BaseLinkFragment
        }
        ... on MediaCarousel {
          ...BaseMediaCarouselFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on SplitPanel {
          ...BaseSplitPanelFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
  }
`;
